<div class="blog-page">
  <section class="blog-hero" *ngIf="blogContent$ | async as blogContent" [style.background-image]="'url(' + getImgSrc(blogContent.heroImage) + ')'">
    <div class="blog-hero__overlay"></div>
    <div class="container blog-hero__content text-center">
      <h1 class="blog-hero__title">{{ blogContent.heroTitle || "The Baker's Journal" }}</h1>
      <p class="blog-hero__subtitle">{{ blogContent.heroSubtitle || "Stories, recipes, and news from inside our kitchen." }}</p>
    </div>
  </section>

  <section class="blog-posts-section">
    <div class="container">
      <div class="blog-grid">
        @if (blogPosts$ | async; as blogPosts) {
          @for (post of blogPosts; track post.id; let i = $index) {
            <article class="blog-card" [style.animation-delay]="(i * 0.1) + 's'">
              <div class="blog-card__image-wrapper">
                <span class="blog-card__category">{{ (post.tags && post.tags.length > 0) ? post.tags[0] : 'News' }}</span>
                <img [src]="getImgSrc(post.imageUrl) || 'https://images.unsplash.com/photo-1549931319-a545dcf3bc73?w=800'" [alt]="post.title" class="blog-card__image">
              </div>
              <div class="blog-card__content">
                <div class="blog-card__meta">
                  <span class="blog-card__date">{{ (post.publishedAt || post.createdAt) | date:'mediumDate' }}</span>
                  <span class="blog-card__author">by {{ post.author || 'The Husk Team' }}</span>
                </div>
                <h2 class="blog-card__title">{{ post.title }}</h2>
                <p class="blog-card__excerpt">{{ post.excerpt }}</p>
                <a [routerLink]="['/blog', post.id]" class="blog-card__read-more">Read Article <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg></a>
              </div>
            </article>
          }
        }
      </div>
    </div>
  </section>
</div>
